// 验证码组件
<template>
<div class="m-captcha" id="captchaBox">
    <!-- 图片验证码输入组件 -->
    <div v-if="capType==1">
    <urs-input ref='capInput' size='small' placeholder='请输入图片验证码' @input="imgcapInput">
    <div class="u-img" @click="initCap()" slot="button"><img class="cap-img" :src="imgCapUrl" alt="点击获取" /></div>
    </urs-input>
    </div>
    <!-- END 图片验证码输入组件 -->
    <!-- 划块\点击式验证码组件 -->
    <div v-show="capType==4||capType==5" class="u-scap" >
        <div ref=sCaptcha class="Scaptcha" id="Scaptcha"></div>
    </div>
    <!-- END 划块\点击式验证码组件 -->
</div>
</template>

<script>
let getWidth = function() {
    let _w = 375;
    _w = document.body.clientWidth
        ? document.body.clientWidth - 50 * 0.8 - 2
        : 375;
    return _w >= 450 || _w <= 0 ? 450 : _w;
};
// 图片验证码正则，1至12位字母或数字
const regimg = /^\w{1,12}$/;
const regimgRight = /^\w{4}$/;

import util from "../util/util"
import { AICAPCONF } from "../util/config"

// 无感知配置
let capConfig = Object.assign( {
    popupStyles: {
        capBarHeight: 40,
        capPadding: 45,
        width: 450,
        top:`auto`
    },
    mode: `bind`
}, AICAPCONF )

export default {
    name: 'urs-capture',
    props: {
        capType: {
            type: Number,
            default: 0
        },
        opd:String,
        capKey: String,
        aiCapKey: String,
        mail: {
            type: String,
            default: ``
        },
        aicapbtn: {
            type: Object,
            default() {
                return {}
            }
        },
        autoVerify: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            imgCapUrl: '',
            verifyFlag: 0,
            capValidate: undefined,
            cycleCount:0
        };
    },
    mounted() {
        // console.log('mounted initcap'+this.capType)
        this.initCap();
    },
    watch: {
        // capType发生变化时，初始化组件
        capType(val) {
            this.initCap();
        }
    },
    beforeDestroy() {
        this.clearStl()
        this.destroyInstance()
    },
    methods: {
        imgcapInput(){
            if (regimgRight.test(this.$refs.capInput.currentValue)){
                this.$emit('verify');
            }
        },
        initImage() {
           var un = '';
           try {
            un = document.getElementsByName('account')[0].value;
           } catch (error) {}
          var imgCapUrl =util.getImgUrl(this.opd,un)
           if (document.referrer && !util.getSmState()){
               // 如果有referrer 增加topURL
               imgCapUrl = imgCapUrl + '&topURL=' + encodeURIComponent(document.referrer.slice(0, 200))
           }
           this.imgCapUrl = imgCapUrl;
            // debugger;
            // @NOTE 清空输入框
            this.$nextTick(()=>{
              this.$refs.capInput.currentValue = '';
            })
        },
        initCap() {
            this.destroyInstance()
            // 图片验证码
            if (this.capType === 1) {
                this.initImage();
            } else{
                 this.loadCap();
            }

        },
        loadCap(){
          if(window.initNECaptcha) {
              this.clearStl()
            if (this.capType === 4 || this.capType === 5) {
                // 重置校验位
              this.initNormalCap()
            } else if(this.capType === 6){
                this.initAiCap()
            }
          }else{
              if(this.cycleCount>=100){
                  this.clearStl();
                  window.showError("加载失败，请刷新页面重试")
              }else{
                 this.stl = setTimeout(()=>{
                 this.cycleCount++;
                 this.loadCap();
                },200)
              }

          }
        },

        getAiCapKey(){
            return capConfig.captchaId
        },
        initNormalCap(){
            let opts = {
                element: this.$refs.sCaptcha, //(div 的 id 名或者使用 document.getElementById('ScapTcha')这种方式)
                captchaType: this.capType - 2, //(控件元素地址)
                captchaId: this.capKey,
                width: getWidth(),
                protocol: 'https',
                mode: 'float',
                wmServerConfig:{
                    "configServer":"webzjac.reg.163.com",
                    "apiServer":"webzjac.reg.163.com",
                    "staticServer":"acstatic-dun.126.net"
                },
                apiServer: ['webzjcaptcha.reg.163.com', 'c.dun.163yun.com'],
                onVerify: this.verifyCallback.bind(this)
                //控件认证结束显示提示的回掉函数，缺省为控件自动 处理信息显示
            };
            opts = this.confV6(opts)
            opts.extraData=this.getExtraData.bind(this);
            initNECaptcha(
                opts,
                this.initCallback.bind(this),
                this.initErrorHandler.bind(this)
            );
        },
        initAiCap(){
            if (!this.aiCapKey){
                window.showError('加载失败，请刷新页面重试');
                // 异常情况，解锁按钮loading状态
                this.$emit('doAiClose')
                return
            }
            capConfig = this.confV6(capConfig)
            capConfig.captchaId = this.aiCapKey
            capConfig.onVerify = this.verifyCallback.bind( this )
            capConfig.extraData = this.getExtraData.bind( this )
            capConfig.element = this.aicapbtn.$refs.mybutton
            if ( util.isMobile() ) {
                // 如果是移动端
                let capWidth = Math.floor( document.body.clientWidth * 0.8 )
                let normalWidth = 240
                capWidth = capWidth >= normalWidth || capWidth <= 0 ? normalWidth : capWidth
                capConfig.popupStyles.width = `${capWidth}`
                capConfig.popupStyles.capPadding = 10
            }
            capConfig.onClose = this.onClose.bind(this)
            capConfig.onReady = this.initCallback.bind( this )
            window.initNECaptcha(
                capConfig,
                function(){},
                this.initErrorHandler.bind( this )
            )
        },
        clearStl(){
            if ( this.stl ) {
                this.stl = clearTimeout( this.stl )
            }
        },
        destroyInstance(){
            this.verifyFlag = 0;
            this.capValidate = undefined;
            if ( this.myCaptcha ) {
                this.myCaptcha = null
            }
        },
        onClose(){
            setTimeout(function(){
                if (this.verifyFlag!==1){
                    this.$emit('doAiClose')
                }
            }.bind(this),200)
        },
        confV6(opts){
            if (window.$NEEDV6){
                opts.ipv6=true;
                // 配置新版滑块的人机
                opts.wmServerConfig={
                    "configServer":"webzjac-v6.reg.163.com",
                    "apiServer":"webzjac-v6.reg.163.com",
                    "staticServer":"acstatic-dun-v6.126.net"
                };
                opts.staticServer=['cstaticdun-v6.126.net'];
                opts.apiServer = ['webzjcaptcha-v6.reg.163.com', 'c-v6.dun.163yun.com'];
            }
            return opts
        },
        // 仅提供刷新功能 不涉及修改验证码类型
        refreshCap() {
            if (this.capType === 1) {
                this.initImage();
            } else {
                // @NOTE 刷新时需要重置成功校验位
                this.verifyFlag = 0;
                if (this.myCaptcha){
                    this.myCaptcha.refresh();
                }
            }
        },
        verifyCallback(err, data) {
            if (data && data.validate) {
                // 验证成功
                this.capValidate = data.validate;
                this.verifyFlag = 1;
                if (this.capType === 6){
                    this.$emit('doVerify')
                }else{
                    this.$emit('verify');
                }
            } else {
                // 验证失败
                this.verifyFlag = 0;
            }
        },
        initCallback(instance) {
            this.myCaptcha = instance;
            this.$emit('initSucc');
            if (this.autoVerify && this.capType === 6){
                // this.myCaptcha.verify()
                this.$emit('autoVerify')
            }
        },
        initErrorHandler(data) {
            this.$emit('initError');
        },
        validate() {
            let msg={
                errorMsg:'',
                status:true
            };
            switch (this.capType) {
                case 1:
                    if (!regimg.test(this.$refs.capInput.currentValue)) {
                         window.showError('请输入图片验证码');
                         msg.status=false;
                    }
                    break;
                case 4:
                    if (!this.verifyFlag) {
                        //msg.errorMsg='请先拖动滑块进行安全验证';
                        window.showError('请先拖动滑块进行安全验证');
                        msg.status=false;
                    }
                    break;
                case 5:
                    if (!this.verifyFlag) {
                        // msg.errorMsg='请先进行验证';
                        window.showError('请先进行验证');
                        msg.status=false;
                    }
                    break;
                case 6:
                    if (!this.verifyFlag) {
                        if (this.myCaptcha){
                            this.$emit('doVerifyLoading')
                            this.myCaptcha.verify()
                        }else{
                            window.showError('加载失败，请刷新页面重试');
                        }
                        msg.status=false;
                    }
                    break;
            }
            return msg;
        },
        getPwd() {
            if (this.capType === 1) {
                return this.$refs.capInput.currentValue;
            } else {
                return this.capValidate;
            }
        },
        getExtraData(){
            return this.mail
        }
    }
};
</script>

<style lang=scss>
.m-captcha {
    position: relative;
    .u-img {
        position: absolute;
        display: block;
        height: 0.8rem;
        width: 2.1rem;
        top: 0.1rem;
        right: 0.08rem;
        background-color: #ddd;
        color: #999;
        line-height: 0.8rem;
        text-align: center;
        cursor: pointer;
        .cap-img {
            width: 100%;
            height: 100%;
        }
    }
    .ncpt_widget {
        .ncpt_panel {
            background-color: #f9f9f9;
        }
        .ncpt_pad,
        .ncpt_puzzle_bg {
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.3);
        }
    }
}
</style>




// WEBPACK FOOTER //
// Capture.vue?2244ec68